import { AddRemoveLicenseModalTranslations } from "./types";

export const enTranslations: AddRemoveLicenseModalTranslations = {
    title: "Remove License Key",
    removalTitle: "Remove license key for ",
    addNewTitle: "Add License Key",
    confirm: "Confirm",
    cancel: "Cancel",
    add: "Submit",
    working: "Saving...",
};
